import createReactComponent from '../createReactComponent';
export default createReactComponent('rss', 'Rss', [["path",{"d":"M6 11.25A6.75 6.75 0 0 1 12.75 18M6 6a12 12 0 0 1 12 12m-11.5-.146.354-.354","key":"svg-0"}]]);